/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import "../sass/main.sass"
import "../../node_modules/lightgallery/dist/css/lightgallery.min.css"
import "@fortawesome/fontawesome-svg-core/styles.css"

import Header from "../components/header/header"
import Footer from "./footer/footer"
import Content from "./content-container/content"

import { library } from "@fortawesome/fontawesome-svg-core"
import { fab } from "@fortawesome/free-brands-svg-icons"
import { fas } from "@fortawesome/pro-solid-svg-icons"
import { fal } from "@fortawesome/pro-light-svg-icons"
import { far } from "@fortawesome/pro-regular-svg-icons"

library.add(fal, fas, fab, far)

const Layout = props => {
  return (
    <>
      <Header />
      <Content>{props.children}</Content>
      <Footer />
    </>
  )
}

export default Layout
